import { render, staticRenderFns } from "./chateau-haut-brion.vue?vue&type=template&id=78853bd5&scoped=true"
import script from "./chateau-haut-brion.vue?vue&type=script&lang=js"
export * from "./chateau-haut-brion.vue?vue&type=script&lang=js"
import style0 from "./chateau-haut-brion.vue?vue&type=style&index=0&id=78853bd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78853bd5",
  null
  
)

export default component.exports